import React, { useState, FC, ReactNode } from 'react';
import { BrandChefsContext } from './context';
import { DefaultconversionListFormData } from 'pages/main-store/brand-chefs/manage-meals/add-manage-meals';
import { ActiveType, ConversionListFormType, ConversionItemType } from 'models/pricing.model';
import { BrandChefsMealFormType } from 'models/brand-chefs.model';
import { ENUM_REQUEST_STATUS } from 'models/common.model';
import { PrepRequestItem, PrepRequestType } from 'models/prep-request.model';

export const DefaultRequestToEdit: Partial<PrepRequestType> = {
  id: '',
  item_type: '',
  code: 0,
  note: '',
  status: ENUM_REQUEST_STATUS.CREATED,
  created_at: '',
  updated_at: '',
  user_id: '',
  items: []
};

export const DefaultItemToEdit: BrandChefsMealFormType = {
  ingredient_name: '',
  ingredient_id: '',
  request_portion: '',
  items: [],
  id: '',
  item_type: ''
};

const BrandChefsProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [conversionListFormData, setConversionListFormData] = useState<ConversionListFormType[]>([
    DefaultconversionListFormData
  ]);
  const [itemToEdit, setItemToEdit] = useState<BrandChefsMealFormType[]>([DefaultItemToEdit]);

  const [active, setActive] = useState<ActiveType | null>(null);
  const [step, setStep] = useState(1);
  const [selectedConversionItem, setSelectedConversionItem] = useState<ConversionItemType | null>(
    null
  );
  const [activeRequest, setActiveRequest] = useState(DefaultRequestToEdit as PrepRequestType);

  const [selectedRequestItem, setSelectedRequestItem] = useState<PrepRequestItem | null>(null);
  return (
    <BrandChefsContext.Provider
      value={{
        conversionListFormData,
        setConversionListFormData,
        itemToEdit,
        setItemToEdit,
        active,
        setActive,
        step,
        setStep,
        selectedConversionItem,
        setSelectedConversionItem,
        activeRequest,
        setActiveRequest,
        selectedRequestItem,
        setSelectedRequestItem
      }}>
      {children}
    </BrandChefsContext.Provider>
  );
};

export default BrandChefsProvider;
